module.exports = __webpack_public_path__ + "img/risklevelR1.3ccee294.png";